import { FiChevronRight } from "react-icons/fi";
import { caseListContainerWrapperClasses } from "./caseListClasses";
import { cn } from "../../utils/classNames";
import { useBreadcrumbContext } from "../../contexts/BreadcrumbContext";
import { useDrawerContext } from "../../contexts/DrawerContext";
import XButton from "./XButton";
import XCrumb from "./XCrumb";
import Tooltip from "../ui-control/Tooltip";
import DrawerExpandIcon from "../../assets/icons/drawerExpand.svg?react";

const navClasses = "flex items-center flex-wrap gap-2 text-sm";
const separatorClasses = "text-subtle";

const GlobalBreadcrumb = () => {
    const { stack, popTo } = useBreadcrumbContext();
    const { isShowDrawerPanel, isDrawerOpen, toggleDrawerPanel } = useDrawerContext();

    const showDrawerExpandIcon = isShowDrawerPanel && !isDrawerOpen;

    if (!stack?.length && !showDrawerExpandIcon) return null;

    return (
        <div className={cn(caseListContainerWrapperClasses, "py-4")}>
            <nav aria-label="breadcrumb" className={navClasses}>
                {showDrawerExpandIcon && (
                    <Tooltip title="Expand Drawer">
                        <XButton variant="link" onClick={toggleDrawerPanel} >
                            <DrawerExpandIcon />
                        </XButton>
                    </Tooltip>
                )}
                {stack.map((frame, index) => {
                    const isLast = index === stack.length - 1;
                    const item = { label: frame.label, onClick: () => popTo(index) };
                    return (
                        <div key={index} className="flex items-center gap-2">
                            {index > 0 && <FiChevronRight className={separatorClasses} aria-hidden="true" />}
                            <XCrumb item={item} isLast={isLast} />
                        </div>
                    );
                })}
            </nav>
        </div>
    );
};

export default GlobalBreadcrumb;
